import actionConstants from '../constants/';

const defaultState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  errorMessage: '',
};

const webhookEventListState = {
  ...defaultState,
};

const webhookEventListForSubscriptionState = {
  ...defaultState,
};

const subscriptionEventListState = {
  ...defaultState,
};

const registerEventListState = {
  ...defaultState,
};

const unregisterEventListState = {
  ...defaultState,
};

const merchantRegisterDataState = {
  ...defaultState,
};
const isMerchantRegisterDataState = {
  ...defaultState,
};

const isMerchantRegisterDataForSubscriptionState = {
  ...defaultState,
};

const initialState = {
  webhookEventListState: {
    ...webhookEventListState,
  },
  webhookEventListForSubscriptionState: {
    ...webhookEventListForSubscriptionState,
  },
  subscriptionEventListState: { ...subscriptionEventListState },
  registerEventListState: { ...registerEventListState },
  unregisterEventListState: { ...unregisterEventListState },
  merchantRegisterDataState: { ...merchantRegisterDataState },
  isMerchantRegisterDataState: { ...isMerchantRegisterDataState },
  isMerchantRegisterDataForSubscriptionState: {
    ...isMerchantRegisterDataForSubscriptionState,
  },
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function webhookEventReducer(state = initialState, action) {
  switch (action.type) {
    case actionConstants.GET_WEBHOOK_EVENT_LIST_REQUEST:
      return {
        ...state,
        webhookEventListState: {
          ...state.webhookEventListState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.GET_WEBHOOK_EVENT_LIST_SUCCESS:
      return {
        ...state,
        webhookEventListState: {
          ...state.webhookEventListState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          [action.payload?.body?.productSystemCode]: action.payload?.body || [],
        },
      };

    case actionConstants.GET_WEBHOOK_EVENT_LIST_FAILURE:
      return {
        ...state,
        webhookEventListState: {
          ...state.webhookEventListState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body?.code,
          errorMessage: action.payload.body?.message,
        },
      };

    case actionConstants.GET_WEBHOOK_EVENT_LIST_CLEAR:
      return {
        ...state,
        webhookEventListState,
      };
    case actionConstants.GET_WEBHOOK_EVENT_LIST_FOR_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        webhookEventListForSubscriptionState: {
          ...state.webhookEventListForSubscriptionState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.GET_WEBHOOK_EVENT_LIST_FOR_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        webhookEventListForSubscriptionState: {
          ...state.webhookEventListForSubscriptionState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          [action.payload?.body?.productSystemCode]: action.payload?.body || [],
        },
      };

    case actionConstants.GET_WEBHOOK_EVENT_LIST_FOR_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        webhookEventListForSubscriptionState: {
          ...state.webhookEventListForSubscriptionState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body?.code,
          errorMessage: action.payload.body?.message,
        },
      };

    case actionConstants.GET_WEBHOOK_EVENT_LIST_FOR_SUBSCRIPTION_CLEAR:
      return {
        ...state,
        webhookEventListForSubscriptionState,
      };
    case actionConstants.GET_SUBSCRIPTION_EVENT_LIST_REQUEST:
      return {
        ...state,
        webhookEventListState: {
          ...state.webhookEventListState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.GET_SUBSCRIPTION_EVENT_LIST_SUCCESS:
      return {
        ...state,
        subscriptionEventListState: {
          ...state.subscriptionEventListState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          [action.payload?.body?.productSystemCode]: action.payload?.body || [],
        },
      };

    case actionConstants.GET_SUBSCRIPTION_EVENT_LIST_FAILURE:
      return {
        ...state,
        subscriptionEventListState: {
          ...state.subscriptionEventListState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body?.code,
          errorMessage: action.payload.body?.message,
        },
      };

    case actionConstants.GET_SUBSCRIPTION_EVENT_LIST_CLEAR:
      return {
        ...state,
        subscriptionEventListState,
      };
    case actionConstants.REGISTER_WEBHOOK_EVENT_LIST_REQUEST:
      return {
        ...state,
        registerEventListState: {
          ...state.registerEventListState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.REGISTER_WEBHOOK_EVENT_LIST_SUCCESS:
      return {
        ...state,
        registerEventListState: {
          ...state.registerEventListState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          [action.payload?.body?.productSystemCode]: action.payload?.body || [],
        },
      };

    case actionConstants.REGISTER_WEBHOOK_EVENT_LIST_FAILURE:
      return {
        ...state,
        registerEventListState: {
          ...state.registerEventListState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body?.code,
          errorMessage: action.payload.body?.message,
        },
      };

    case actionConstants.REGISTER_WEBHOOK_EVENT_LIST_CLEAR:
      return {
        ...state,
        registerEventListState,
      };

    case actionConstants.UNREGISTER_WEBHOOK_EVENT_LIST_REQUEST:
      return {
        ...state,
        unregisterEventListState: {
          ...state.unregisterEventListState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.UNREGISTER_WEBHOOK_EVENT_LIST_SUCCESS:
      return {
        ...state,
        unregisterEventListState: {
          ...state.unregisterEventListState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          [action.payload?.body?.productSystemCode]: action.payload?.body || [],
        },
      };

    case actionConstants.UNREGISTER_WEBHOOK_EVENT_LIST_FAILURE:
      return {
        ...state,
        unregisterEventListState: {
          ...state.unregisterEventListState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body?.code,
          errorMessage: action.payload.body?.message,
        },
      };

    case actionConstants.UNREGISTER_WEBHOOK_EVENT_LIST_CLEAR:
      return {
        ...state,
        unregisterEventListState,
      };
    case actionConstants.REGISTER_MERCHANT_ON_WEBHOOK_EVENT:
      return {
        ...state,
        merchantRegisterDataState: {
          ...state.merchantRegisterDataState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.REGISTER_MERCHANT_ON_WEBHOOK_EVENT_SUCCESS:
      return {
        ...state,
        merchantRegisterDataState: {
          ...state.merchantRegisterDataState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          [action.payload?.body?.productSystemCode]: action.payload?.body || [],
        },
      };

    case actionConstants.REGISTER_MERCHANT_ON_WEBHOOK_EVENT_FAILURE:
      return {
        ...state,
        merchantRegisterDataState: {
          ...state.merchantRegisterDataState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body?.code,
          errorMessage: action.payload.body?.message,
        },
      };

    case actionConstants.REGISTER_MERCHANT_ON_WEBHOOK_EVENT_CLEAR:
      return {
        ...state,
        merchantRegisterDataState,
      };
    case actionConstants.STATUS_OF_REGISTER_MERCHANT_ON_WEBHOOK_EVENT:
      return {
        ...state,
        isMerchantRegisterDataState: {
          ...state.isMerchantRegisterDataState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.STATUS_OF_REGISTER_MERCHANT_ON_WEBHOOK_EVENT_SUCCESS:
      return {
        ...state,
        isMerchantRegisterDataState: {
          ...state.isMerchantRegisterDataState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          [action.payload?.body?.productSystemCode]: action.payload?.body || [],
        },
      };

    case actionConstants.STATUS_OF_REGISTER_MERCHANT_ON_WEBHOOK_EVENT_FAILURE:
      return {
        ...state,
        isMerchantRegisterDataState: {
          ...state.isMerchantRegisterDataState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body?.code,
          errorMessage: action.payload.body?.message,
        },
      };

    case actionConstants.STATUS_OF_REGISTER_MERCHANT_ON_WEBHOOK_EVENT_CLEAR:
      return {
        ...state,
        isMerchantRegisterDataState,
      };
    case actionConstants.STATUS_OF_REGISTER_MERCHANT_ON_WEBHOOK_EVENT_FOR_SUBSCRIPTION:
      return {
        ...state,
        isMerchantRegisterDataForSubscriptionState: {
          ...state.isMerchantRegisterDataForSubscriptionState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.STATUS_OF_REGISTER_MERCHANT_ON_WEBHOOK_EVENT_FOR_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        isMerchantRegisterDataForSubscriptionState: {
          ...state.isMerchantRegisterDataForSubscriptionState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          [action.payload?.body?.productSystemCode]: action.payload?.body || [],
        },
      };

    case actionConstants.STATUS_OF_REGISTER_MERCHANT_ON_WEBHOOK_EVENT_FOR_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        isMerchantRegisterDataForSubscriptionState: {
          ...state.isMerchantRegisterDataForSubscriptionState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body?.code,
          errorMessage: action.payload.body?.message,
        },
      };

    case actionConstants.STATUS_OF_REGISTER_MERCHANT_ON_WEBHOOK_EVENT_FOR_SUBSCRIPTION_CLEAR:
      return {
        ...state,
        isMerchantRegisterDataForSubscriptionState,
      };
    default:
      return state;
  }
}
